<template>
  <highlight-card
    :button="{ label: texts.photosCta }"
    :heading="`${texts.slideshowHeading} ${deceasedName}`"
    :status="count"
    :text="slideshow.sectionLead"
    @action="addPhoto"
  >
    <template #media>
      <film-poster
        :image="image"
        :label="slideshow.play"
        :text="slideshow.heading"
        @play="openViewer({ source: 'current_events' })"
      />
    </template>
  </highlight-card>
</template>

<script lang="ts" setup>
  import {
    openViewer,
    quickContent,
    slideshowPoster,
    slideshowTexts,
  } from "Plugins/obituary/javascript/composables/useSlideshow";
  import { MEDIA_INITIAL } from "Plugins/obituary/javascript/createCommentStepsHelper";
  import { highlightTexts } from "Plugins/obituary/javascript/highlights/texts";
  import { filmSettings } from "Plugins/obituary/javascript/slideshow/film";
  import { mediaCount } from "Plugins/obituary/javascript/slideshow/playlist";
  import { sprintf } from "sprintf-js";
  import { useStore } from "vuex";
  import HighlightCard from "../HighlightCard.vue";
  import FilmPoster from "./FilmPoster.vue";

  defineProps<{ deceasedName: string }>();

  const store = useStore();
  const texts = highlightTexts();
  const slideshow = slideshowTexts();
  const content = quickContent();
  const image = slideshowPoster();
  // What the film plays, after the family's choices; always MIN_PHOTOS or more here.
  const count = content
    ? sprintf(texts.photosCount, mediaCount(content, filmSettings(content)))
    : undefined;

  function addPhoto() {
    store.dispatch("createComment/toggleModal", MEDIA_INITIAL);
  }
</script>
